/**
 * EventsTimelineGroupRows
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EventsTimelineRow from '../EventsTimelineRow';
import NoJobsScheduledMessage from './components/NoJobsScheduledMessage';

// Selectors
import { selectEventsTimelineGroupIds } from '../../selectors';

interface Props {
    eventsTimelineGroupIds?: number[];
}

export class EventsTimelineGroupRows extends React.PureComponent<Props> {
    render() {
        const { eventsTimelineGroupIds } = this.props;
        if (!eventsTimelineGroupIds || !eventsTimelineGroupIds.length) {
            return <NoJobsScheduledMessage />;
        }
        return eventsTimelineGroupIds.map(groupId => (
            <EventsTimelineRow key={groupId} groupId={groupId} />
        ));
    }
}

const mapStateToProps = createStructuredSelector({
    eventsTimelineGroupIds: selectEventsTimelineGroupIds
});

export default connect(mapStateToProps)(EventsTimelineGroupRows);
